import React from 'react';
import { StyleSheet, Text, View } from '../base_components';

import { BusyComponent, BusyOverlay } from '../busy_component';
import Overlay from './overlay';
import TextButton from '../buttons/text_button';
import ProgressSpinner from '../progress_spinner';

import MediaStore from '../../stores/media_store';

const styles = StyleSheet.create({
  mediaOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  dialog: {
    padding: '3em',
    width: 'auto',
    minWidth: '20em',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  stat: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  label: {
    width: '10em',
    color: 'black',
    fontSize: '1.2em',
  },
  value: {
    color: '#333',
    fontSize: '1.2em',
  },
  statRight: {
    flexDirection: 'column',
  },
  listValue: {
    marginBottom: '0.5em',
    color: '#333',
    fontSize: '1.2em',
  },
  button: {
    marginTop: '2em',
    height: '3em',
  },
  buttonView: {
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

type Props = {
  media: any;
  volumeId: number;
  onMediaRefresh: () => void;
  onClose: () => void;
};
type State = {
  media_detail: any;
};

export default class MediaOverlay extends BusyComponent<Props, State> {
  state = {
    media_detail: null,
  };
  componentDidMount() {
    const { volumeId, media } = this.props;
    const opts = {
      volume_id: volumeId,
      media_id: media.media_id,
    };
    MediaStore.getMedia(opts, (err, result) => {
      if (!err && result) {
        this.setState({ media_detail: result });
      }
    });
  }

  _onMediaDownload = () => {
    const { volumeId, media } = this.props;
    if (this.setBusy()) {
      const { media_id } = media;
      MediaStore.requestDownload({ volume_id: volumeId, media_id }, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to get URL.  Please try again.');
        } else {
          window.alert(
            'Request in progress, check your FileRunner account shortly to download this file.'
          );
        }
      });
    }
  };
  _onMediaUndelete = () => {
    const { volumeId, media } = this.props;
    if (this.setBusy()) {
      const { media_id } = media;
      MediaStore.undelete({ volume_id: volumeId, media_id }, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Undelete failed');
        } else {
          media.is_deleted = 0;
          this.forceUpdate();
          this.props.onMediaRefresh();
          window.alert('Undeleted!');
        }
      });
    }
  };

  render() {
    const { media, onClose } = this.props;
    const { media_detail } = this.state;
    const { media_id, media_path, file_hash, file_size, is_deleted } = media;
    const file = media_path.match(/[^/]*$/)[0];
    const path = media_path.slice(0, media_path.length - file.length);

    let deleted = null;
    let undelete = null;
    if (is_deleted) {
      deleted = <Stat label='Status' value='deleted' />;
      undelete = (
        <TextButton
          style={styles.button}
          text='Undelete File'
          onPress={this._onMediaUndelete}
        />
      );
    }
    let detail = null;
    if (media_detail) {
      const {
        last_update_user_name,
        in_s3,
        in_filerunner,
        in_filestore,
        hash_containers,
      } = media_detail;
      let status = 'Not Uploaded';
      if (in_s3) {
        status = 'In S3';
      } else if (in_filerunner) {
        status = 'In Filerunner';
      } else if (in_filestore) {
        status = 'In Filestore';
      }
      let containers = null;
      if (hash_containers.length === 0) {
        containers = 'None';
      } else {
        const list = hash_containers.map((device, i) => (
          <Text key={i} style={styles.listValue}>
            {device.device_name}
          </Text>
        ));
        containers = <View style={styles.statRight}>{list}</View>;
      }

      detail = (
        <>
          <Stat label='Last Update User' value={last_update_user_name} />
          <Stat label='Upload Status' value={status} />
          <Stat label='Hash Stewards' value={containers} />
        </>
      );
    } else {
      detail = <ProgressSpinner />;
    }

    return (
      <View style={styles.mediaOverlay}>
        <Overlay dialogStyle={styles.dialog} onClose={onClose}>
          <Stat label='Media ID' value={media_id} />
          <Stat label='File' value={file} />
          <Stat label='Path' value={path} />
          <Stat label='Hash' value={file_hash} />
          <Stat label='Size' value={file_size} />
          <Stat
            label='Last Updated'
            value={new Date(media.last_updated).toLocaleString()}
          />
          {detail}
          {deleted}
          <View style={styles.buttonView}>
            <TextButton
              style={styles.button}
              text='Download File'
              onPress={this._onMediaDownload}
            />
            {undelete}
          </View>
        </Overlay>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Stat(props) {
  const { label, value } = props;
  const right =
    typeof value !== 'object' ? (
      <Text style={styles.value}>{value}</Text>
    ) : (
      value
    );
  return (
    <View style={styles.stat}>
      <Text style={styles.label}>{label + ':'}</Text>
      {right}
    </View>
  );
}
